export function createFunctionWithMethods<Fn extends (...args: any[]) => any, Methods extends Record<string, (...args: any[]) => any>>(
    fn: Fn,
    methods: Methods,
): Fn & Methods {
    Object.assign(fn, methods);
    return fn as Fn & Methods;
}
